import ar from './ar/common';
import en from './en/common';

const messages = {
  ar: {
    translation: ar
  },
  en: {
    translation: en
  }
};

export default messages;